import { render, staticRenderFns } from "./AccordionItem.vue?vue&type=template&id=300403eb&"
import script from "./AccordionItem.vue?vue&type=script&lang=js&"
export * from "./AccordionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/santiagoas/Documents/MultiContentWidget/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('300403eb')) {
      api.createRecord('300403eb', component.options)
    } else {
      api.reload('300403eb', component.options)
    }
    module.hot.accept("./AccordionItem.vue?vue&type=template&id=300403eb&", function () {
      api.rerender('300403eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/components/AccordionItem.vue"
export default component.exports